import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import BaseApi from '../api/BaseApi';
import ApiKey from "../api/ApiKey";
import Cookies from "js-cookie";
import Swal from 'sweetalert2';

const RazorpayButton = ({ amount }) => {

    const params = useParams();
    // console.log("Params:", params.slug);
    const [isLoading, setIsLoading] = useState(false);

    let paymentSlug;
    const tokenKey = Cookies.get("tokenClient");
    const userType = Cookies.get("user_type");
    const curr = Cookies.get("curr");
    const currency = Cookies.get("currency");
    const razorpayKeyId = Cookies.get("razorpay_key_id");
    const navigate = useNavigate();

    const handlePayment = async () => {

        try {
            setIsLoading(true);

            const { data } = await axios.post(BaseApi + '/payments/createOrder', {
                // amount: amount, // e.g., 500 for ₹500
                plan_id: params.slug, // Assuming slug is the plan ID

            }, {
                headers: {
                    'Content-Type': 'application/json',
                    key: ApiKey,
                    token: tokenKey
                }
            });
            setIsLoading(false);

            paymentSlug = data.payment_slug;

            const options = {
                key: razorpayKeyId, // from Razorpay dashboard
                amount: amount * 100,
                currency: currency || 'INR', // Default to INR if curr is not set
                name: data.user_name,
                description: 'Payment for subscription',
                order_id: data.order_id,
                handler: function (response) {
                    // alert(`Payment successful! Payment ID: ${response.razorpay_payment_id}`);

                    paymentCompleted(response.razorpay_payment_id)
                    // Optionally, verify payment on server
                },
                prefill: {
                    name: data.user_name || 'Your Name',
                    email: data.email,
                    contact: data.contact, // Default contact number
                },
                notes: {
                    address: data.address || 'Corporate Office'
                },
                theme: {
                    color: data.color_theme_code || '#F37254' // Default theme color
                },
                modal: {
                    ondismiss: function () {
                        // Handle payment cancellation or modal close
                        Swal.fire({
                            title: 'Payment Cancelled',
                            text: 'The payment was cancelled or closed. You will be redirected to your account.',
                            icon: 'warning',
                            confirmButtonText: 'OK',
                        }).then(() => {
                            // Navigate based on userType
                            if (userType === 'candidate') {
                                navigate('/candidates/myaccount');
                            }
                            if (userType === 'recruiter') {
                                navigate('/user/myprofile');
                            }
                        });
                    },
                },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (error) {
            setIsLoading(false);
            console.error('Payment Error:', error);
        }
    };

    const paymentCompleted = async (paymentId) => {

        // return;
        setIsLoading(true);
        try {
            const response = await axios.post(BaseApi + `/payments/checkoutSuccess/${paymentSlug}`, {
                plan_id: params.slug, // Assuming slug is the plan ID
                payment_slug: paymentSlug,
                payment_id: paymentId,
                transaction_id: paymentId,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    key: ApiKey,
                    token: tokenKey
                }
            });
            setIsLoading(false);

            if (response.data.status === 200) {
                Swal.fire({
                    title: 'Payment Successful',
                    text: 'Your payment has been completed successfully.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => {
                    if (userType === "candidate") {
                        navigate("/candidates/myaccount");
                    }
                    if (userType === "recruiter") {
                        navigate("/user/myprofile");
                    }
                });
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Error completing payment:', error);
            Swal.fire({
                title: 'Payment Failed',
                text: 'There was an error completing your payment. Please try again later.',
                icon: 'error',
                confirmButtonText: 'OK'
            }).then(() => {

                if (userType === "candidate") {
                    navigate("/candidates/myaccount");
                }
                if (userType === "recruiter") {
                    navigate("/user/myprofile");
                }
            });
        }
    };

    useEffect(() => {
        handlePayment();
    }, []);

    return (
        <>
            {isLoading && (
                <div className="pleaseWaitStripe">
                    <img src="/Images/credit-card.gif" alt="payment" />
                </div>  
            )
            }
            {/* <button onClick={handlePayment} className="bg-blue-600 text-white px-4 py-2 rounded">
                Pay ₹{amount}
            </button> */}
        </>
    );
};

export default RazorpayButton;
